<template>
    <b-card :title="title">
            
        <b-card-header >   
            <b-row>
                <b-col class="col-md-7">
                    <b-input v-model="filter" type="search" placeholder="Search item type..."></b-input>
                </b-col>

                <b-col >
                    <slot></slot>
                </b-col>

            </b-row>
        </b-card-header>

        <b-card-body>
            
            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows/itemsPerPage) }} Total:
                {{  rows}}
            </p>

            <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
      :current-page="currentPage" :filter="filter">
                <template #cell(id)="row">
                    <!-- render the view button only if the user's permissions allow it -->
                    <b-button
                    v-if="hasPermissionCreate"
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>

            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>





        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orderCategories-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: {
        //type, // not used

        /**
         * List of items to  be displayed in the table
         */
        items: Array,
        /**
         * The title of the table
         */
        title: String,
    },

    data() {
        return {
            componentName:'Activity Category',
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            fields: [{ key: 'id', label: 'Actions' }, 'name'],
        }
    },

    mounted() {},

    methods: {
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `Are you sure you want to delete ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('orderCategory/delete', id)
                        .then(() => {
                        
                            this.genericToast(this.componentName,'Deleted','success', `"${item.name}"" deleted successfully`)

                            // this.doToast(
                            //     'Deleted!',
                            //     'Your Item has been deleted.',
                            //     'success'
                            // )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete item!',
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }
        
    },
}
</script>
<style></style>
